import uuid from 'uuid/v4';

// eslint-disable-next-line import/no-mutable-exports
var toExport = uuid;
if (process.env.NODE_ENV === 'test') {
  toExport = function toExport() {
    return 'id.test';
  };
}
export default toExport;